let cartService = {
	// Check the loginState of user and return the value
	async checkLoginState (url) {
		const info = fetch(url)
		.then((res) => res ? res.json() : res)
		.then((res) => {
			if (res) {
				return res.loginState
			} else {
				return false
			}
		},
		(e) => {
			console.error('Error when checking loginState:', e)
			return false
		})
		return info
	},
	// Get the cart for the current OSP-store and return the value if it has items in it
	async getOcadoCart (token, cartUrl) {
		let parameters = {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json'
			},
			method: 'GET'
		}
		try {
			return await fetch(cartUrl, parameters)
				.then((res) => res.json())
				.then((response) => {
					if (response.fault) {
						return null
					} else if (response.cart) {
						if (response.cart.totalSum == '0.00' || !response.cart.totalItems) {
							return null
						} else {
							const cartData = {
								total: response.cart.totalSum == '0.00' ? 0 : response.cart.totalSum,
								quantity: response.cart.totalItems
							}
							return cartData
						}
					}
				})
		} catch(error) {
			console.error('Error when fetching OSP-cart: ',error)
			return null
		}
	},
	async addToOcadoCart (item, url, token) {
		if (!url || !token || !item) {
			return false
		}
		let parameters = {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json'
			},
			method: 'POST',
			body: '',
		}
		parameters.body = JSON.stringify(item)
		return await fetch(url, parameters)
	},
	// This is a call to check if the OSP-store is available to get cart and add products
	async isOSPAvailable (token, url) {
		let parameters = {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json'
			},
			method: 'GET'
		}
		try {
			return await fetch(url, parameters)
			.then((res) => res.json())
			.then((response) => {
				return response
			})
		} catch (error) {
			console.error('Error in isOSPAvailable: ', error)
			return false
		}
	},
	async checkEmail (url, token) {
		let parameters = {
			headers: {
				Authorization: `Bearer ${token}`,
				'Content-Type': 'application/json'
			},
			method: 'GET'
		}
		try {
			return await fetch(url, parameters)
			.then((res) => res.json())
			.then((response) => {
				return response
			})
		} catch (error) {
			console.error('Error in checkEmail: ', error)
			return false
		}
	}
}

export default cartService 

